export const environment = {
  production: true,
  apiurl: 'https://hvarest.omnicms3.nl:9501/api/v1/',
  mock: false,
  config: {
    product: "Mijn HvA-Pas",
    customer_fullname: "Hogeschool van Amsterdam",
    customer_shortname: "HVA",
    url: "https://omnicard.nl/product/omnipas",
    phone: "+31 20 595 1403",
    email: "servicedesk-fs@hva.nl",
    MFAemail: false,
    MFAsms: false,
    logintype : "database",
    autologin: false,
    username: "",
    password: "",
    samlConfig: {},
    surfConfig: { issuer: "https://connect.surfconext.nl"
                , clientId : "mijnhvapas.nl"
                , redirectUri: "https://www.mijnhvapas.nl/site/surflogin"
                , silentRefreshRedirectUri: "https://www.mijnhvapas.nl/site/silent-refresh.html"
                , logoutUrl: "https://engine.surfconext.nl/logout"
                , scope: "openid profile email"
                , loginItem: "uids"
                , oidc: true
                , skipPage: false
                , secret: "FajkLiKelmNON5mSE3wA"
                },
    adfsConfig: {},
    psptype: "worldlinedirect",
    ingenico: {
      url: "https://secure.ogone.com/ncol/prod/orderstandard.asp",
      orderid: "CARD 206103 ",
      pspid: "HvAiDeal",
      sha_in_key: "ie!wufbw98234#342@234h238",
      sha_out_key: "@DJ@d32283d0j1j2233@39+",
      currency: "EUR",
      bgcolor: "#F3F3F3",
      txtcolor: "#004C93",
      tblbgcolor: "#FFFFFF",
      tbltxtcolor: "#666666",
      buttonbgcolor: "#004C93",
      buttontxtcolor: "#FFFFFF",
      fonttype: "Verdana",
      pm: "iDEAL",
      homeurl: "https://www.mijnhvapas.nl/site/payment",
      accepturl: "https://www.mijnhvapas.nl/site/payment/success",
      declineurl: "https://www.mijnhvapas.nl/site/payment/decline",
      exceptionurl: "https://www.mijnhvapas.nl/site/payment/fail",
      cancelurl: "https://www.mijnhvapas.nl/site/payment/cancel"
    },
    postcode: {
      url: "https://api.postcode.eu/nl/v1/addresses/postcode/",
      key: "s4k7iIx6OiEwbZypep1zZWBeZiYJOpkyDyvzPUCDjZt",
      secret: "AksxuszQHWXjBf9G604vmUhyNq2nOSxKohtns6rnhJSKqXT3uk"
    },
    cardprices: { "Student": 1, "Employee": 0, "External employee": 0, "default": 1500 },
    languages: [
      {
        id: 1,
        LanguageCode: "nl",
        LanguageName: "Nederlands",
        Card: "pas"
      },
      {
        id: 2,
        LanguageCode: "en",
        LanguageName: "English",
        Card: "pass"
      }

    ],
    nameoncardformats: [
      { id: 1, format: "<<Initials>> <<MiddleName>> <<LastName>>" },
      { id: 2, format: "<<FirstName>> <<MiddleName>> <<LastName>>" },
      { id: 3, format: "<<LastName>>, <<FirstName>> <<MiddleName>>" }
    ],
    savephotoonserver: false,
    changepublishpermission: false,
    chargingcard: false,
    digitalcard: false,
    uploadphoto: true,
    webcam: true,
    licenseplate: false,
    nameoncard: false,
    cardpreview: true,
    cardaslink: false,
    cardresult: true,
    cardactivate: false,
    cardblock: true,
    carddeblock: false,
    cardrequest: true,
    logoutbutton: false,
    requestnewpassword: false,
    publishPermission: false,
    scrollButtons: true,
    breadcrumbs: false,
    versioninfooter: false,
    photoResizeToWidth: 480,
    photoMiniatureWidth: 240,
    togglefont: false,
    photorequirements: true,
    firstnameonwelcome: false,
    photoAgreedNotOnFirstPage: true,
    deliveryaddress: false,
    deliveryaddress2: true,
    langimage: false,
    maintainance: false,
    timeout: 180,
  },
  ssl: true
};
